import Http from "./base-http";

class StoreModuleDisabled extends Http {
  deleteStoreModuleDisabled(id) {
    return this.destroy(id);
  }
  createStoreModuleDisabled(variables) {
    return this.create(variables);
  }
}
const storeModuleDisabledObj = new StoreModuleDisabled({
  modelUrlPrefix : "StoreModuleDisabled"
});

export default storeModuleDisabledObj;